import Vue from 'vue'
import Router from 'vue-router'
import wx from 'weixin-js-sdk'
import { signature } from "@/api/common";

// import Login from "../views/user/login"
// import Video from "../views/video/video"
// import Pool from "../views/index/pool/pool"
// import Manuscript from "../views/manuscript"
// import ClassSubject from "../views/index/classSubject/classSubject"
// import CloudClassroom from "../views/index/cloudClassroom/cloudClassroom"
// import Laborer from "../views/index/laborer/laborer"
// import Loading from "../views/loading"
// import Start from "../views/start"


Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/index',
      redirect:'/index',
      component: (resolve) => require(['@/layout/index'], resolve),
      hidden: true,
      children:[
        // 资源池
        {
          name: "index",
          path: '/index',
          component: (resolve) => require(['@/views/index/index'], resolve),
        },
        {
          name: "user",
          path: '/user',
          component: (resolve) => require(['@/views/user/user'], resolve),
        },
        // // 课代表
        // {
        //   name: "classSubject",
        //   path: '/classSubject',
        //   component: ClassSubject,
        // },
        // // 云课堂
        // {
        //   name: "cloudClassroom",
        //   path: '/cloudClassroom',
        //   component: CloudClassroom,
        // },
        // // 劳动家
        // {
        //   name: "laborer",
        //   path: '/laborer',
        //   component: Laborer,
        // },
      ]
    },
    {
      name: "think",
      path: '/think',
      component: (resolve) => require(['@/views/index/classSubject/think'], resolve),
    },
    // 视频上传
    {
      name: "video",
      path: '/video',
      component: (resolve) => require(['@/views/video/video'], resolve),
    },
    // 图文上传
    {
      name: "articleImage",
      path: '/articleImage',
      component: (resolve) => require(['@/views/video/articleImage'], resolve),
    },
    // 加载
    {
      name: "loading",
      path: '/',
      component: (resolve) => require(['@/views/loading'], resolve),
    },
    // 开始页
    {
      name: "start",
      path: '/start',
      component: (resolve) => require(['@/views/start'], resolve),
    },
    // 登录
    {
      name: "login",
      path: '/login',
      component: (resolve) => require(['@/views/user/login'], resolve),
    },
    // 登录
    {
      name: "loginInfo",
      path: '/loginInfo',
      component: (resolve) => require(['@/views/user/loginInfo'], resolve),
    },
     // 稿件正文
     {
      name: "manuscript",
      path: '/manuscript',
      component: (resolve) => require(['@/views/manuscript'], resolve),
    },
     // 云课堂 稿件list
     {
      name: "essayList",
      path: '/essayList',
      component: (resolve) => require(['@/views/essayList'], resolve),
    },
    // 二级页面Zha
    // 05红领巾课代表-同参与
    {
      name: "sameParticipation",
      path: '/sameParticipation',
      component: (resolve) => require(['@/views/sameParticipation/index'], resolve),
    },
    // 06我的-基本资料
    {
      name: "baseInfo",
      path: '/user/baseInfo',
      component: (resolve) => require(['@/views/user/baseInfo'], resolve),
    },
    // // 06我的-消息
    {
      name: "message",
      path: '/message',
      component: (resolve) => require(['@/views/user/message'], resolve),
    },
    // 06我的-作品
    {
      name: "workList",
      path: '/user/workList',
      component: (resolve) => require(['@/views/user/workList'], resolve),
    },
    // 06我的-我的积分
    {
      name: "integral",
      path: '/user/integral',
      component: (resolve) => require(['@/views/user/integral'], resolve),
    },

    // 视频
    {
      name: "videoDetails",
      path: '/videoDetails',
      component: (resolve) => require(['@/views/videoDetails/index'], resolve),
    },
    {
      name: "articleImageDetails",
      path: '/articleImageDetails',
      component: (resolve) => require(['@/views/articleImageDetails/index'], resolve),
    },
    {
      name: "answer",
      path: '/answer',
      component: (resolve) => require(['@/views/answer/index'], resolve),
    },
    
    {
      name: "typeArticle",
      path: '/typeArticle',
      component: (resolve) => require(['@/views/typeArticle'], resolve),
    },
    {
      name: "sameParticipationDetail1",
      path: '/sameParticipationDetail1',
      component: (resolve) => require(['@/views/sameParticipationDetail1'], resolve),
    },
    {
      name: "sameParticipationDetail2",
      path: '/sameParticipationDetail2',
      component: (resolve) => require(['@/views/sameParticipationDetail2'], resolve),
    },
    {
      name: "sameParticipationDetail3",
      path: '/sameParticipationDetail3',
      component: (resolve) => require(['@/views/sameParticipationDetail3'], resolve),
    },
    {
      name: "sameParticipationDetail4",
      path: '/sameParticipationDetail4',
      component: (resolve) => require(['@/views/sameParticipationDetail4'], resolve),
    },
    {
      name: "sameParticipationDetail5",
      path: '/sameParticipationDetail5',
      component: (resolve) => require(['@/views/sameParticipationDetail5'], resolve),
    },
    {
      name: "sameParticipationDetail6",
      path: '/sameParticipationDetail6',
      component: (resolve) => require(['@/views/sameParticipationDetail6'], resolve),
    },
    {
      name: "sameParticipationDetail7",
      path: '/sameParticipationDetail7',
      component: (resolve) => require(['@/views/sameParticipationDetail7'], resolve),
    },
    {
      name: "sameParticipationDetail8",
      path: '/sameParticipationDetail8',
      component: (resolve) => require(['@/views/sameParticipationDetail8'], resolve),
    },
    {
      name: "sameParticipationDetail9",
      path: '/sameParticipationDetail9',
      component: (resolve) => require(['@/views/sameParticipationDetail9'], resolve),
    },
    {
      name: "sameParticipationDetail11",
      path: '/sameParticipationDetail11',
      component: (resolve) => require(['@/views/sameParticipationDetail11'], resolve),
    },
    {
      name: "sameParticipationDetail12",
      path: '/sameParticipationDetail12',
      component: (resolve) => require(['@/views/sameParticipationDetail12'], resolve),
    }
    
  ]
})
router.beforeEach((to, from,next) => {
  
  
  // document.write('<script id="_trs_ta_js" src="https://ta.trs.cn/c/js/ta.js?mpid=6336&r='+ Math.random()+'" async="async" defer="defer"></script>')
  
  
  // 增加数据埋点
  // var script = document.createElement('script');
  // script.src = 'https://ta.trs.cn/c/js/ta.js?mpid=3064&r='+ Math.random()
  // script.id = '_trs_ta_js'
  // script.async = 'async'
  // script.defer = 'defer'
  // // 移除旧的script标签
  // var oldScript = document.getElementById('_trs_ta_js');
  // if (oldScript) {
  //     oldScript.parentNode.removeChild(oldScript);
  // }
  // document.body.appendChild(script);
  if(from.name == 'manuscript'&&document.title!='红领巾 劳动吧'||from.name == 'videoDetails'){
    document.title = '红领巾 劳动吧'
    // registerWX()
  }
  // return true
  next()
})
function registerWX() {
  let _url = location.href.split("#")[0];
  let _this = this
  signature({ url: _url }).then(res => {
    const wxData = res.data;
    wx.config({
      debug: false,
      appId: wxData.appid,
      timestamp: wxData.timestamp,
      nonceStr: wxData.nonceStr,
      signature: wxData.signature,
      jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
    });
    wx.ready(() => {
      let wxData = {
        title: '红领巾 劳动吧',
        desc: '全国首个少先队员劳动教育实践网上平台',
        link: _url,
        imgUrl: 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg'
      };
      let pengyouquanData = {
        title: '红领巾 劳动吧',
        desc: '全国首个少先队员劳动教育实践网上平台',
        link: _url,
        imgUrl: 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg'
      };
      wx.updateAppMessageShareData(wxData);
      wx.updateTimelineShareData(pengyouquanData);
    });
  });
}
export default router


// WEBPACK FOOTER //
// ./src/router/index.js